<template>
  <div class="bg">
    <div class="container1">
      <div class="total-num">
        <img src="../img/place_total.png" class="total-img">
        <div>
          <div class="total-font" style="color: #1362FF;">场所总数</div>
          <div class="total-number" style="color: #1362FF;">{{ mainData.placeCount }}</div>
        </div>
      </div>
      <div class="total-num">
        <img src="../img/gateway_total.png" class="total-img">
        <div>
          <div class="total-font" style="color: #18887B;">网关设备总数</div>
          <div class="total-number" style="color: #18887B;">{{ mainData.gatewayCount }}</div>
        </div>
      </div>
      <div class="total-num">
        <img src="../img/sensor_total.png" class="total-img">
        <div>
          <div class="total-font" style="color: #5F41FF;">传感器设备总数</div>
          <div class="total-number" style="color: #5F41FF;">{{ mainData.deviceCount }}</div>
        </div>
      </div>
    </div>

<!--    <div class="smart-detection-environmental-monitoring-line">-->
<!--      <div class="smart-detection-environmental-monitoring-line-item" v-for="item in mainData">-->
<!--        <div class="smart-detection-environmental-monitoring-line-item-top">-->
<!--          <div>{{item.powerRoomName}}</div>-->
<!--          <div class="smart-detection-environmental-monitoring-line-item-top-video" @click="preview(item)" v-if="item.videoDeviceCode">-->
<!--            <i class="el-icon-damai-ic_Indoormonitoring"></i>-->
<!--            <div>视频</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="smart-detection-environmental-monitoring-line-item-main">-->
<!--          <div class="smart-detection-environmental-monitoring-line-item-main-load-rate" v-if="item.status === 0">正常</div>-->
<!--          <div class="smart-detection-environmental-monitoring-line-item-main-load-rate-abnormal" v-else>异常</div>-->
<!--          <div class="smart-detection-environmental-monitoring-line-item-main-environment">-->
<!--            <div class="smart-detection-environmental-monitoring-line-item-main-environment-line">-->
<!--              <i class="iconfont el-icon-damai-shineiwendu"></i>-->
<!--              <div>温度 {{item.temperature}}℃</div>-->
<!--            </div>-->
<!--            <div class="smart-detection-environmental-monitoring-line-item-main-environment-line">-->
<!--              <i class="iconfont el-icon-damai-shineishidu"></i>-->
<!--              <div>湿度 {{item.humidity}}%</div>-->
<!--            </div>-->
<!--            <div class="smart-detection-environmental-monitoring-line-item-main-environment-line">-->
<!--              <i class="iconfont el-icon-damai-shineishuijin"></i>-->
<!--              <div>水浸 <span v-if="item.waterOut === '0'" style="color: #3B7CFF">正常</span><span style="color: #FD6450" v-else>异常</span></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <el-dialog :title="previewDeviceName" :visible.sync="dialogVisible" width="600px">-->
<!--      <div class="video-page-right-main-box">-->
<!--        <HlsVideo v-if="previewProtocolType === '大华云睿' && videoUrl" class="video-page-right-main-box-choose DHVideoPlayer" />-->
<!--        <HKPlayer v-if="previewProtocolType === '海康云眸' && hkVideoPlayerLink" :hkVideoPlayerLink="hkVideoPlayerLink" />-->
<!--      </div>-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
import { api } from "../../api/SmartDetection";
import TableMain from "../../../components/Table/TableMain";
import { nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
import OverViewTopLine from "../../../components/OverView/OverViewTopLine";
import { iconListChoose } from "../../../utils/icon";
import UpperLiquidFill from "../../../components/UpperEcharts/upperLiquidFill";
import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/ChartTimeSelect";
import CommonLine from "../../../components/Echarts/Line/commonLine";
export default {
  name: "SmartDetectionOverView",
  components: {CommonLine, ChartTimeSelect, UpperLiquidFill, OverViewTopLine, TableMain },
  data() {
    return {
      overViewTopData: [],

      transformerList: [],

      followingCapacitySeries: [],
      betweenCapacitySeries: [],
      aboveCapacitySeries: [],

      yearElectricity: '0',
      monthElectricity: '0',


      environmentMonitorList: [],

      dialogVisible: false,
      previewDeviceName: '',
      previewDeviceCode: '',
      previewProtocolType: '大华云睿',
      dHPreviewToken: '',
      hkVideoPlayerLink: '',
      videoUrl: '',

      mainData:{}
    };
  },
  created() {
    // this.getDeviceOverview();
    // this.getDeviceList();
    // this.getDeviceCapcity();
    // this.getUsedElectricity()
    // this.getEnvironmentMonitorList()
    this.getOverViewStatistics()
    this.getAllPlaceStatistics()
  },
  methods: {
    getAllPlaceStatistics(){
      this.$axios.get(api.getAllPlaceStatistics).then(res=>{
        console.log(res)
      }).catch(errorHandler('获取数据失败'))
    },
    getOverViewStatistics(){
      this.$axios.get(api.getOverViewStatistics).then(res=>{
        this.mainData=res.data.data
      }).catch(errorHandler('获取数据失败'))
    },

    // 获取设备数量
    getDeviceOverview() {
      this.$axios
        .post(api.getDeviceOverview, {})
        .then((res) => {
          let data = res.data.data;
          let overViewTopData = [
            [
              {code: "低压进线柜", name: "低压进线柜", value: "0", unit: "台", color: "#1362FF", icon: iconListChoose("低压进线柜"),},
              {code: "高压进线柜", name: "高压进线柜", value: "0", unit: "台", color: "#18887B", icon: iconListChoose("高压进线柜"),},
              {code: "高压计量柜", name: "高压计量柜", value: "0", unit: "台", color: "#5E41FE", icon: iconListChoose("高压计量柜"),},
              {code: "低压补偿柜", name: "低压补偿柜", value: "0", unit: "台", color: "#F29324", icon: iconListChoose("低压补偿柜"),},
              {code: "高压进线隔离", name: "高压进线隔离", value: "0", unit: "台", color: "#8B36EF", icon: iconListChoose("高压进线隔离"),},
              {code: "低压配电柜", name: "低压配电柜", value: "0", unit: "台", color: "#50B5FF", icon: iconListChoose("低压配电柜"),},
            ],
            [
              {code: "低压出线柜", name: "低压出线柜", value: "0", unit: "台", color: "#1362FF", icon: iconListChoose("低压出线柜"),},
              {code: "高压出线柜", name: "高压出线柜", value: "0", unit: "台", color: "#18887B", icon: iconListChoose("高压出线柜"),},
              {code: "高压压变柜", name: "高压压变柜", value: "0", unit: "台", color: "#5E41FE", icon: iconListChoose("高压压变柜"),},
              {code: "低压联络柜", name: "低压联络柜", value: "0", unit: "台", color: "#F29324", icon: iconListChoose("低压联络柜"),},
              {code: "高压避雷器柜", name: "高压避雷器柜", value: "0", unit: "台", color: "#8B36EF", icon: iconListChoose("高压避雷器柜"),},
              {code: "其他配电柜", name: "其他配电柜", value: "0", unit: "台", color: "#50B5FF", icon: iconListChoose("其他配电柜"),},
            ],
            [
              {code: "变压器", name: "变压器", value: "0", unit: "台", color: "#1362FF", icon: iconListChoose("变压器"),},
              {code: "配电箱", name: "配电箱", value: "0", unit: "台", color: "#18887B", icon: iconListChoose("配电箱"),},
              {code: "进线提升柜", name: "进线提升柜", value: "0", unit: "台", color: "#5E41FE", icon: iconListChoose("进线提升柜"),},
              {code: "动力柜", name: "动力柜", value: "0", unit: "台", color: "#F29324", icon: iconListChoose("动力柜"),},
              {code: "高压电缆", name: "高压电缆", value: "0", unit: "台", color: "#8B36EF", icon: iconListChoose("高压电缆"),},
              {}
            ]
          ];
          overViewTopData.map(line => {
            line.map(v => {
              let powerBoxDTOS = data.powerBoxDTOS || [];
              powerBoxDTOS.map((power) => {
                if (v.name === power.deviceType) {
                  v.value = power.count || "0";
                }
              });
            })
          });
          this.overViewTopData = overViewTopData;
        })
        .catch(errorHandler("获取设备数量失败"));
    },

    // 获取容量占比
    getDeviceCapcity() {
      this.$axios
        .post(api.getDeviceCapcity, {})
        .then((res) => {
          let data = res.data.data;
          this.followingCapacitySeries = [
            {
              name: "500kVA以下",
              type: "liquidFill",
              radius: "80%",
              data: [data.kva500Rate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#4C92FE",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold",
                  },
                },
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    { offset: 1, color: ["#C9DEFF"] },
                    { offset: 0, color: ["#C9DEFF"] },
                  ],
                  global: false, // 缺省为 false
                },
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  color: "none",
                  shadowBlur: 20,
                  shadowColor: "#ffffff",
                  borderColor: "#4C92FE",
                  borderWidth: 8,
                },
              },
              backgroundStyle: {
                color: "transparent", // 图表的背景颜色
              },
            },
          ];
          this.betweenCapacitySeries = [
            {
              name: "500-2000kVA以下",
              type: "liquidFill",
              radius: "80%",
              data: [data.kva500To2000Rate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#FEAC4C",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold",
                  },
                },
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    { offset: 1, color: ["#FFE6C9"] },
                    { offset: 0, color: ["#FFE6C9"] },
                  ],
                  global: false, // 缺省为 false
                },
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  color: "none",
                  shadowBlur: 20,
                  shadowColor: "#ffffff",
                  borderColor: "#FEAC4C",
                  borderWidth: 8,
                },
              },
              backgroundStyle: {
                color: "transparent", // 图表的背景颜色
              },
            },
          ];
          this.aboveCapacitySeries = [
            {
              name: "2000kVA以下",
              type: "liquidFill",
              radius: "80%",
              data: [data.kva2000Rate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#9E4CFE",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold",
                  },
                },
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    { offset: 1, color: ["#E2C9FF"] },
                    { offset: 0, color: ["#E2C9FF"] },
                  ],
                  global: false, // 缺省为 false
                },
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  color: "none",
                  shadowBlur: 20,
                  shadowColor: "#ffffff",
                  borderColor: "#9E4CFE",
                  borderWidth: 8,
                },
              },
              backgroundStyle: {
                color: "transparent",
              },
            },
          ];
        })
        .catch(errorHandler("获取容量占比失败"));
    },

    // 获取电量
    getUsedElectricity () {
      this.$axios.get(api.getUsedElectricity, {})
        .then(res => {
          let data = res.data.data
          this.yearElectricity = data.yearElectricity || '0'
          this.monthElectricity = data.monthElectricity || '0'
        })
        .catch(errorHandler('获取电量失败'))
    },

    // 查询变压器列表
    getDeviceList() {
      this.$axios
        .post(api.getDeviceList, {})
        .then((res) => {
          this.transformerList = res.data.data;
        })
        .catch(errorHandler("查询变压器失败"));
    },

    // 获取运行监测数据
    getRunMonitor() {
      this.$axios
        .post(api.getRunMonitor, {})
        .then((res) => {
          let data = res.data.data;
          data.lineParam.map((v) => {
            v.rateText = `${v.rate}%`;
          });
          this.operatingParametersTableData = data.lineParam || [];
          this.loopStateTableData = data.lineType || [];
          this.capacitanceTemperatureTableData = data.lineTemperature || [];
        })
        .catch(errorHandler("获取运行监测数据失败"));
    },

    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },


    // 查询列表
    getEnvironmentMonitorList () {
      this.$axios.post(api.getEnvironmentMonitorList, {})
        .then(res => {
          let data = res.data.data
          this.environmentMonitorList = data
        })
        .catch(errorHandler('查询信息失败'))
    },

    // 预览
    preview (row) {
      let deviceName = row.videoDeviceName
      let deviceCode = row.videoDeviceCode
      let protocolType = row.videoDeviceProtocolType
      this.previewDeviceName = deviceName
      this.previewDeviceCode = deviceCode
      this.previewProtocolType = protocolType
      let url = ''
      if (protocolType === '大华云睿') {
        url = `${api.getVideoHlsStream}`
      } else {
        url = `${api.preview}`
      }
      this.$axios.post(url, {
        deviceCode: deviceCode
      })
        .then(res => {
          let data = res.data.data
          if (data) {
            if (protocolType === '大华云睿') {
              this.dialogVisible = true
              this.$nextTick(() => {
                this.videoUrl = data.hls
              })
            } else if (protocolType === '海康云眸') {
              this.isPlayHKVideo = true
              let token = data
              let channelNum = row.deviceId
              this.hkVideoPlayerLink = `https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${deviceCode}/${channelNum || '1'}.live&autoplay=1&accessToken=${token}`
              setTimeout(() => {
                this.isPlayHKVideo = false
              }, 120000)
              // this.play(token, deviceCode)
            }
          }
        })
        .catch(errorHandler('预览失败'))
    },
  },
};
</script>

<style scoped lang="less">
.smart-detection-over-view {
  .smart-detection-top-over-view-line {
    display: flex;
    justify-content: space-between;
    .smart-detection-top-person-count-box {
      width: 30%;
      height: 160px;
      padding: 10px 10px;
      border-radius: 10px;
      color: #ffffff;
      background-color: #00a0e6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #dcdfe6;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      i {
        width: 30%;
        font-size: 48px;
      }
      .smart-detection-top-person-count-box-info {
        width: 70%;
        text-align: left;
        .smart-detection-top-person-count {
          font-size: 36px;
          font-weight: 600;
          word-wrap: break-word;
          .smart-detection-top-person-count-unit {
            font-size: 12px;
          }
        }
        .smart-detection-top-person-tip {
          font-size: 16px;
        }
      }
    }
    .smart-detection-top-over-view-line-left {
      width: 49%;
      padding: 10px 10px;
      border-radius: 0 !important;
      border: 1px solid #dcdfe6;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    }
    .smart-detection-top-over-view-line-right {
      width: 49%;
      padding: 10px 10px;
      border-radius: 0 !important;
      border: 1px solid #dcdfe6;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    }
  }

  .smart-detection-over-view-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .smart-detection-over-view-line-item {
      width: 48%;
      height: 220px;
      margin-top: 20px;
      padding: 10px 0;
      border-radius: 7px;
      box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px 0px,
        rgba(0, 0, 0, 0.04) 0px 0px 6px 0px;
      .smart-detection-over-view-line-item-title {
        height: 24px;
        font-size: 17px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        line-height: 24px;
        padding: 14px 21px;
        color: #333333;
        text-align: left;
      }
      .smart-detection-over-view-line-item-capacity {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .smart-detection-over-view-line-item-capacity-item {
          width: 140px;
          height: 132px;
          margin-top: 20px;
          .smart-detection-over-view-line-item-capacity-item-liquid-fill {
            width: 102px;
            height: 102px;
            margin: 0 auto;
          }
          .smart-detection-over-view-line-item-capacity-item-text {
            height: 22px;
            font-size: 15px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            line-height: 22px;
            color: #505050;
          }
        }
      }

      .smart-detection-over-view-line-item-electricity-line {
        height: 50%;
        padding: 0 17px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .smart-detection-over-view-line-item-electricity-line-title {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          color: #333333;
        }
        .smart-detection-over-view-line-item-electricity-line-main {
          margin-left: 8px;
          .smart-detection-over-view-line-item-electricity-line-main-item {
            width: 47px;
            height: 62px;
            line-height: 62px;
            font-size: 32px;
            font-weight: 600;
            font-family: sans-serif;
            background: url("../../../assets/number_bg.png") 100% 100% no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .transformer-line {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    margin: 20px 0;
    .transformer-line-item {
      width: 48%;
      margin: 20px 0;
      padding: 0 0 10px 0;
      border-radius: 7px;
      box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px 0px,
        rgba(0, 0, 0, 0.04) 0px 0px 6px 0px;
      .transformer-line-item-top {
        padding: 10px 20px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgb(220, 223, 230);
        background: #f2f7ff;
      }
      .transformer-line-item-main {
        margin-top: 20px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .transformer-line-item-main-load-rate {
          width: 30%;
          position: relative;
          .transformer-line-item-main-load-rate-img {
            width: 100%;
          }
          .transformer-line-item-main-load-rate-tip {
            width: 100%;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            position: absolute;
            left: 0;
            bottom: 0;
            color: #2cd5ef;
            background: #e5f8fb;
          }
        }
        .transformer-line-item-main-info {
          width: 20%;
          font-size: 14px;
          font-family: Source Han Sans SC;
          .transformer-line-item-main-info-title {
            height: 24px;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            color: #333333;
          }
          .transformer-line-item-main-info-item {
            margin: 0 auto;
            font-size: 12px;
            font-weight: 400;
            line-height: 35px;
            color: #0062ff;
            width: 100px;
            height: 35px;
            background: #f2f7ff;
            border-radius: 3px 3px 0px 0px;
          }
          .transformer-line-item-main-environment-item {
            margin: 0 auto;
            font-size: 12px;
            font-weight: 400;
            line-height: 53px;
            color: #0062ff;
            width: 100px;
            height: 53px;
            background: #f2f7ff;
            border-radius: 3px 3px 0px 0px;
          }
        }
      }
    }
  }


  .smart-detection-environmental-monitoring-line {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    margin: 20px 0;
    .smart-detection-environmental-monitoring-line-item {
      width: 650px;
      height: 282px;
      background: #FFFFFF;
      border-radius: 7px;
      margin: 0 0 20px;
      padding: 0;
      border: 1px solid rgb(220, 223, 230);
      box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px 0px, rgba(0, 0, 0, 0.04) 0px 0px 6px 0px;
      .smart-detection-environmental-monitoring-line-item-top {
        height: 41px;
        line-height: 41px;
        font-size: 18px;
        font-weight: bolder;
        background: #F2F8FF;
        border-radius: 7px 7px 0px 0px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .smart-detection-environmental-monitoring-line-item-top-video {
          color: #0062FF;
          cursor: pointer;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .el-icon-damai-ic_Indoormonitoring {
            font-size: 24px;
            margin-right: 5px;
          }
        }
      }
      .smart-detection-environmental-monitoring-line-item-main {
        margin-top: 20px;
        padding: 0 100px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .smart-detection-environmental-monitoring-line-item-main-load-rate {
          width: 120px;
          height: 120px;
          line-height: 80px;
          border-radius: 50%;
          border: 20px solid #3B7CFF;
        }
        .smart-detection-environmental-monitoring-line-item-main-load-rate-abnormal {
          width: 120px;
          height: 120px;
          line-height: 80px;
          border-radius: 50%;
          border: 20px solid #FD6450;
        }
        .smart-detection-environmental-monitoring-line-item-main-environment {
          width: 171px;
          height: 180px;
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          .smart-detection-environmental-monitoring-line-item-main-environment-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 171px;
            height: 47px;
            line-height: 47px;
            background: #F7FAFF;
            border-radius: 12px;
            i {
              color: #4C92FE;
              font-size: 42px;
              background: #E6F0FF;
              border-radius: 12px;
            }
            div {
              flex: 1;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>

<style scoped lang="less">
.bg{
  background-color: #f1f0f7;
}
.container1{
  display: flex;
  margin-top:20px;
}
.total-num{
  width:518px;
  height:120px;
  border-radius: 10px;
  background: #FFFFFF;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.total-img{
  width:56px;
  height:56px;
  margin-right:50px
}
.total-font{
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
}
.total-number{
  font-size: 42px;
  font-family: D-DIN;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionOverView/SmartDetectionOverView.vue